import React from 'react';
import styled from 'styled-components';
import { ExpandMore, ExpandLess } from '@mui/icons-material';

type SubTitleProps = {
  title: string;
  index?: number | string;
  expand?: boolean;
  setExpand?: (expand: boolean) => void;
};

export const SubTitle: React.FunctionComponent<SubTitleProps> = (
  props: SubTitleProps,
) => {
  const { title, index, expand, setExpand } = props;

  if (index !== undefined && expand !== undefined && setExpand) {
    return (
      <Container
        onClick={() => {
          setExpand(!expand);
        }}
      >
        <div>{expand ? <ExpandLess /> : <ExpandMore />}</div>
        <div>
          {title} - {typeof index === 'number' ? index + 1 : index}
        </div>
      </Container>
    );
  } else {
    return (
      <Container style={{ cursor: 'default' }}>
        <div style={{ marginLeft: '1.5rem' }}>{title}</div>
      </Container>
    );
  }
};

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
  background-color: #951d1d;
  color: #fff;
  font-size: 1rem;
  padding: 1.15rem 0.5rem;
  cursor: pointer;
`;
